import React, { useState, useEffect, useMemo } from 'react';
import {
    Row,
    Col,
    Container,
} from 'reactstrap';
import CommonService from 'services/CommonService';
import CustomLoader from 'components/Common/CustomLoader';
import UseDebounce from 'components/shared/UseDebounce';
import { IColumnModel } from 'models/IColumnModel';
import { ISearchModel } from 'models/ISearch.Model';
import CustomDataTable from 'components/shared/CustomDataTable';
import { aes_encryption } from '../../helpers/Helper'

function ImportHistoryList() {
    const [importHistory, setImportHistory] = useState<Array<any>>([]);
    const [isload, setIsLoad] = useState(false);
    const [searchText, setSearchText] = useState<any>();
    const debouncedSearch = UseDebounce(searchText, 1000);
    const [rowsPerPage] = useState<number>(10);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const columns: IColumnModel[] = useMemo(() => [
         {
            Header: 'Id',
            accessor: 'Id',
            width: "1%",
            displayInList: false,
            Filter: false,
        },
        {
            Header: 'Imported By',
            accessor: 'ImportedBy',
            width: "5%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'File Name',
            accessor: 'FileName',
            width: "5%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Is Imported',
            accessor: 'IsImported',
            width: "2%",
            displayInList: true,
            Filter: true,
            datatype: "importBoolean"
        },
        {
            Header: 'Total',
            accessor: 'TotalCount',
            width: "2%",
            displayInList: true,
            Filter: true,
        }, {
            Header: 'Valid',
            accessor: 'ValidCount',
            width: "2%",
            displayInList: true,
            Filter: true,
        }, {
            Header: 'Modified',
            accessor: 'ModifiedCount',
            width: "3%",
            displayInList: true,
            Filter: true,
        }, {
            Header: 'Invalid',
            accessor: 'InValidCount',
            width: "3%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Imported Date',
            accessor: 'ImportDate',
            displayInList: true,
            width: "10%",
            Filter: false,
            datatype: "datetime",
        },
    ], []);

    const GetImportHistory = (pageNumber: any, searchText: any, sortOrder?: string, sortcolumn?: string) => {
        setIsLoad(true);
        let searchModel: ISearchModel = {
            offsetStart: offsetStart,
            rowsPerPage: rowsPerPage,
            sortOrder: sortOrder ?? "DESC",
            sortOrderColumn: sortcolumn ?? "Modified",
            searchText: searchText,
        }

        CommonService.post("sell", "GetImportHistoryList", searchModel).then(res => {
            if (res.status == 200) {
                let data = res.data;
                setImportHistory(data);
                setTotalRecords(data[0]?.TotalRowsCount);
                setIsLoad(false);
            }
        });
    }

    const searchHandler = (searchKeyword: any) => {
        setSearchText(searchKeyword);
        GetImportHistory(0, searchKeyword);
    }

    const onColumnSortChange = (columnName, sortorder) => {
        setSelectedColumn(columnName);
        setSortOrder(sortorder);
    };

    const pagination = (pageNumber: any) => {
        GetImportHistory(pageNumber, debouncedSearch, selectedColumn, sortOrder);
    }

    const editHandler = (row: any) => {
        if (row?.Id) {
            const url = `/import-history/${aes_encryption(row?.Id)}`;
            window.open(url, '_blank');
        }
    };

    useEffect(() => {
        GetImportHistory(0, debouncedSearch);
    }, [offsetStart, rowsPerPage]);

    return (
        <div className="page-content">
            <CustomLoader isOpen={isload} />
            <Container fluid className="p-0">
                <div className="d-flex justify-content-between">
                    <h5 className="fw-semibold text-dofy dofy-admin-font-md mb-3" style={{ whiteSpace: "nowrap" }}>Import History</h5>
                </div>
                <Row>
                    <Col xl={12}>
                        <CustomDataTable
                            isPagination={importHistory[0]?.TotalRowsCount > 50 ? true : true}
                            customPageSize={50}
                            isActionEdit={false}
                            isActionDelete={false}
                            editHandler={editHandler}
                            isGlobalFilter={true}
                            searchHandler={searchHandler}
                            onColumnSortChange={onColumnSortChange}
                            canShowButton1={false}
                            selectedPage={pagination}
                            canShowButton2={false}
                            deleteHandler={undefined}
                            createHandler={undefined}
                            path={''}
                            firstBtnName={''}
                            specialGrid={false}
                            recordsCount={importHistory[0]?.TotalRowsCount}
                            pageSize={rowsPerPage}
                            columns={columns}
                            data={importHistory}
                            rowsPerPage={rowsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            offsetStart={offsetStart}
                            setOffsetStart={setOffsetStart}
                            canImportView={true}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ImportHistoryList;